import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import './styles.scss';

const Switch = ({ size, checked, onChange, formId, label, className, labelclassName }) => (
  <div className={classnames('switch-component', className)}>
    {label && <div className={classnames('switch-label', labelclassName)}>{label}</div>}
    <div className={classnames('switch', size)}>
      <input type="checkbox" id={formId} className="switch-input"
        checked={checked}
        onChange={onChange} />
      <label className="switch-paddle" htmlFor={formId} />
    </div>
  </div>
);

Switch.propTypes = {
  size: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  formId: PropTypes.string.isRequired,
};

export default Switch;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/Switch/index.js